import { FormattedMessage } from 'react-intl';
import TextButton from 'components/TextButton';
import logoAllTrailsMarkSrc from 'components/icons/logo-alltrails-mark.svg';
import RegisterForm from 'components/RegisterForm';
import TermsOfService from 'components/TermsOfService';
import Typography from 'components/Typography';
import User from '@alltrails/shared/types/User';
import { useDispatch } from 'react-redux';
import * as styles from './CreateAccount.module.scss';
import { setUser } from '../../userSlice';

// Desktop: https://app.zeplin.io/project/6218dc5177101a641929be50/screen/6218e0969a14ec615b010af1
// Mobile: https://app.zeplin.io/project/6218dc5177101a641929be50/screen/6218dd22bac7766468e03a73

const br = () => <br />;

type Props = {
  handleLoginClick: () => void;
  onSuccess: () => void;
  redirectUrl?: string;
};

export default function CreateAccount({ handleLoginClick, onSuccess, redirectUrl }: Props) {
  const dispatch = useDispatch();

  function handleRegistrationSuccess({ user }: { user: User }) {
    if (redirectUrl) {
      window.location.assign(redirectUrl);
    } else {
      dispatch(setUser(user));
      onSuccess();
      google.accounts.id.cancel();
    }
  }

  return (
    <div className={styles.content}>
      <Typography component="div" mb="24">
        <img alt="" src={logoAllTrailsMarkSrc} />
      </Typography>
      <Typography component="div" mb="16" variant="title2">
        <FormattedMessage defaultMessage="Create a free account<br></br>to save your adventures." values={{ br }} />
      </Typography>
      <RegisterForm autoFocus handleRegistrationSuccess={handleRegistrationSuccess} />
      <Typography component="div" mb="48" variant="body2">
        <FormattedMessage defaultMessage="Already have an account?" />{' '}
        <TextButton color="green" onClick={handleLoginClick}>
          <FormattedMessage defaultMessage="Log in" />
        </TextButton>
      </Typography>
      <TermsOfService />
    </div>
  );
}
